import React from 'react';
import { Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useNavigateWithScrollMemory } from '../../hooks/useNavigateWithScrollMemory';
import theme from '../../theme';

const ReviewContentLink = ({ content, to, state, sx, lineClamp = 3 }) => {
  const navigateWithScrollMemory = useNavigateWithScrollMemory();

  const handleClick = (e) => {
    if (!e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      navigateWithScrollMemory(to, state ? { state } : undefined);
    }
  };

  return (
    <RouterLink
      to={to}
      state={state}
      onClick={handleClick}
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      <Typography
        sx={{
          color: theme.palette.black[6],
          display: '-webkit-box',
          WebkitLineClamp: lineClamp,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          wordBreak: 'break-word',
          lineHeight: '1.5',
          cursor: 'pointer',
          ...sx,
        }}
      >
        {content}
      </Typography>
    </RouterLink>
  );
};

export default ReviewContentLink;
